import React, { useEffect } from 'react'
import { TableFooter, TablePagination, Box, Badge, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Switch, Button, CircularProgress } from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles'
import {green, grey} from '@material-ui/core/colors'
import Typography from '@material-ui/core/Typography'
import MakeOrganization from '../MakeOrganization';
import MakeIcon from '@material-ui/icons/Add'
import Orgs from '../../services/organization'
import Auth from '../../services/auth'
import Notify from '../Notify'
import StatusIcon from '@material-ui/icons/FiberManualRecord';

const GreenSwitch = withStyles({
  switchBase: {
    color: grey[300],
    '&$checked': {
      color: green[500]
    },
    '&$checked + $track': {
      backgroundColor: green[500],
    }
  },
  checked: {},
  track: {}
})(Switch)

const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);

const StatusIndicator = ({ status }) => {
  const [currentStep, setCurrentStep] = React.useState(0)
  const [stepStatus, setStepStatus] = React.useState('PENDING')

  const getColor = (stepStatus) => {
    console.log('getColor', stepStatus)
    switch (stepStatus) {
      case 'FAIL':
        return '#ff3b3b'; // Red for error
      case 'SUCCESS':
        return '#4caf50'; // Green for success
      case 'PENDING':
      case 'INPROGRESS':
        return '#ff9800'; // Yellow for warning
      default:
        return '#e0e0e0'; // Gray for unknown
    }
  };

  const statusSteps = ['connectWaba', 'subAccount', 'phoneAssignment', 'whatsAppSender', 'whatsAppTemplates']
  const statusLabels = {
    'connectWaba': 'Connecting WhatsApp Business Account',
    'subAccount': 'Creating Sub Account',
    'phoneAssignment': 'Assigning Phone Number',
    'whatsAppSender': 'Preparing WhatsApp Sender',
    'whatsAppTemplates': 'Creating WhatsApp Templates',
    'active': 'Active'
  }

  useEffect(() => {
    if (!status) {
      setStepStatus('UNREGISTERED')
      setCurrentStep(5)
    } else if (status.done) {
      console.log('status.done', status)
      setCurrentStep(5)
      setStepStatus('SUCCESS')
    } else {
      for (let i = statusSteps.length - 1; i > 0; i--) {
        if (status[statusSteps[i]] === 'PENDING') {
          continue
        }
    
        console.log('status', i, statusSteps[i], status[statusSteps[i]])
    
        setCurrentStep(i)
        setStepStatus(status[statusSteps[i]])
        break
      }
    }
  }, [])

  if (!status) {
    return (
      <Typography>
        <StatusIcon style={{fontSize: '12px', color: getColor(stepStatus)}} /> Unregistered
      </Typography>
    )
  }

  return (    
    <Typography>
      <StatusIcon style={{fontSize: '12px', color: getColor(stepStatus)}} /> {status.done ? 'Active' : statusLabels[statusSteps[currentStep]]}
    </Typography>
  );
};

export default function WhatsAppStatusTable (props) {
  const [timer, setTimer] = React.useState(null)
  const [count, setCount] = React.useState(0)
  const [showMakeOrg, setShowMakeOrg] = React.useState(false)
  const [query, setQuery] = React.useState({limit: 10, page: 0, name: ''})
  const [orgs, setOrgs] = React.useState([])
  const [notify, setNotify] = React.useState({show: false})
  const [promptStatusChange, setPromptStatusChange] = React.useState({show: false, org: null})
  const [promptDeleteOrg, setPromptDeleteOrg] = React.useState({show: false, org: null, loading: false})

  const onChangeQuery = function (newQuery) {
    setQuery(newQuery)

    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }
    
    setTimer(setTimeout(function () {
      console.log('query orgs', newQuery)
      Orgs.query(newQuery)
        .then(orgs => {
          setOrgs(orgs)
          setCount(orgs.length) // temp
        })
        .catch(err => {
          console.error('OrganizationsTable.orgs.get.failed', err)
          setOrgs([])
          setCount(0)
        })
    }, 500))
  }

  React.useEffect(() => {
    Orgs.query(query)
      .then(orgs => {
        console.log('init.orgs', orgs)
        setOrgs(orgs)
        setCount(orgs.length) // temp
      })
  }, [query])

  const headers = [
    {
      label: 'Organization Name',
      key: 'name'
    },
    {
      label: 'WhatsApp Onboard Status',
      key: 'status'
    },
    {
      label: 'Sub Account SID',
      key: 'subAccountSid'
    },
    {
      label: 'WABA ID',
      key: 'wabaId'
    },
    {
      label: 'Phone Number',
      key: 'phoneNumber'
    }
  ]
  const onNotifyClose = function () {
    setNotify({show: false})
  }

  const onSelect = function (id) {
    if (props.onSelect) {
      props.onSelect(id)
    }
  }

  return (
    <React.Fragment>
      {/* {promptStatusChange.show && <ConfirmStatusChange onClose={onConfirmStatusChange} active={!promptStatusChange.org.disabled} />}
      {promptDeleteOrg.show && <ConfirmDeleteOrganization onClose={onDeleteOrganization} organizationName={promptDeleteOrg.org.name} loading={promptDeleteOrg.loading} />} */}
      {notify.show && <Notify variant={notify.variant} onClose={onNotifyClose} message={notify.message} />}
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        WhatsApp Status for Organizations
      </Typography>
      {/* <Typography variant="h5">My Programs</Typography> */}
      <TableContainer component={Paper}>
        <Table aria-label="Table of WhatsApp Onboarding Status for each Organization">
          <TableHead>
            {/* <TableRow>
              <TableCell>
                <TextField label="Search by name" value={query.name} onChange={(e) => onChangeQuery({...query, name: e.target.value})} fullWidth />
              </TableCell>
            </TableRow> */}
            <TableRow>
              {headers.map(header => <TableCell key={header.key}>{header.label}</TableCell>)}
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {
              orgs
                .map(row => (
                  <TableRow key={row.id}>
                    {
                      headers
                        .map(header => {
                          switch (header.key) {
                            case 'stats_sent':
                              return <TableCell key={`${row.id}_${header.key}`}>{row.stats.sent}</TableCell>
                            case 'status':
                              return <TableCell key={`${row.id}_${header.key}`}>
                                <StatusIndicator status={(row.settings || {}).status} />
                              </TableCell>
                            case 'wabaId':
                            case 'subAccountSid':
                              return <TableCell key={`${row.id}_${header.key}`}>{(row.settings || {})[header.key] || 'Not Available'}</TableCell>
                            case 'name':
                              return <TableCell key={`${row.id}_${header.key}`}>
                                <Button onClick={() => onSelect(row.id)}>
                                  {row.name}
                                </Button>
                              </TableCell>
                            default:
                              return <TableCell key={`${row.id}_${header.key}`}>{row[header.key]}</TableCell>
                          }
                        })
                    }
                    <TableCell>
                      
                    </TableCell>
                  </TableRow>
                ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  )
}